import React from 'react';
import {
  Coffee,
  Star,
  Award,
  UtensilsCrossed,
  Croissant,
  Cookie,
  IceCream,
  Wine,
  Soup,
  Salad,
  Sandwich,
  Pizza,
  Flame,
} from 'lucide-react';

export const categoryIcons: Record<string, React.ElementType> = {
  Coffee,
  Beverages: Coffee,
  'Hot Drinks': Coffee,
  'Cold Drinks': IceCream,
  Desserts: Cookie,
  Pastries: Croissant,
  Snacks: Sandwich,
  'Main Course': UtensilsCrossed,
  Appetizers: Soup,
  Salads: Salad,
  Pizza,
  Wine,
  Food: UtensilsCrossed,
  Drinks: Coffee,
  Sweets: Cookie,
  Breakfast: Croissant,
  Lunch: UtensilsCrossed,
  Dinner: UtensilsCrossed,
  Cigarettes: Flame,
};

export const getCategoryIcon = (category: string): React.ElementType => {
  if (category === "Today's Specials") return Star;
  if (category === 'Featured Items') return Award;
  return categoryIcons[category] || UtensilsCrossed;
};
